class PBGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pb-thumb]');
      if (!button) return;
      const index = button.dataset.pbThumb;
      this.querySelectorAll('[data-pb-slide]').forEach((slide) => {
        const selected = slide.dataset.pbSlide === index;
        slide.hidden = !selected;
        slide.classList.toggle('is-active', selected);
      });
      this.querySelectorAll('[data-pb-thumb]').forEach((thumb) => thumb.setAttribute('aria-pressed', String(thumb === button)));
    });
  }
}
if (!customElements.get('pb-gallery')) customElements.define('pb-gallery', PBGallery);
document.addEventListener('click', (event) => {
  if (event.target.closest('.pb-mobile-nav-panel a')) {
    event.target.closest('details').open = false;
  } else if (!event.target.closest('.pb-mobile-nav')) {
    document.querySelectorAll('.pb-mobile-nav[open]').forEach((nav) => { nav.open = false; });
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.pb-mobile-nav[open]').forEach((nav) => {
    nav.open = false; nav.querySelector('summary').focus();
  });
});
